export default __webpack_public_path__ + "static/media/btn-tire-selected.5a79713a.png";